import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { browserHistory } from 'react-router';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import {
  ModalOverlay,
  ResponsiveContent,
  ModalCloseHeader
} from '@evdy/web-core/dist/components/shared/Modal2020';
import TextInput from '../TextInput';

import { webCommunityOperations } from '@evdy/web-redux/dist/lib/webCommunity';

import styles from './NotYouDetailsModal.module.scss';

const { createUser, resetStaging } = webCommunityOperations;

const {
  'not-you-details-modal': notYouDetailsModalClass,
  'not-you-details-body': notYouDetailsBodyClass,
  inputs: inputsClass,
  'button-container': buttonContainerClass
} = styles;

const NotYouDetailsModal = ({ baseRoute, closeModal, pendingComment }) => {
  const { userCreated, memorialId } = useSelector(({ webCommunity }) => ({
    memorialId: webCommunity.inviteMeta.data?._id,
    userCreated: webCommunity.messageStaging.userCreated
  }));
  const dispatch = useDispatch();
  // TODO: see if we can consolidate Yup schema validation somehow post-MVP
  const emailRegex = /^\S+@\S+\.\S+$/;

  const NotYouDetailsFormSchema = Yup.object().shape({
    name: Yup.string().required('This is required!'),
    email: Yup.string()
      .matches(emailRegex, 'Please provide a valid email')
      .required('Please enter your email')
  });

  const onSubmit = ({ name, email }) => {
    dispatch(createUser({ memorialId, name, email }));
  };

  // reopen post message if user is created
  useEffect(() => {
    if (userCreated) {
      if (pendingComment) {
        browserHistory.push({
          pathname: `${baseRoute}/messages/${pendingComment.mediaId}`,
          state: { message: pendingComment.message }
        });
        dispatch(resetStaging());
      } else {
        browserHistory.push({ pathname: `${baseRoute}/condolence/create` });
      }
    }
  }, [baseRoute, dispatch, pendingComment, userCreated]);

  return (
    <ModalOverlay modalVisible {...{ closeModal }} customClass={notYouDetailsModalClass}>
      <ResponsiveContent>
        <ModalCloseHeader {...{ closeModal }} />
        <div className={notYouDetailsBodyClass}>
          <h3>Please add your details below</h3>
          <Formik
            initialValues={{ name: '', email: '' }}
            validationSchema={NotYouDetailsFormSchema}
            onSubmit={onSubmit}
          >
            <Form>
              <div className={inputsClass}>
                <TextInput
                  type="text"
                  label="Full Name (required)"
                  name="name"
                  placeholder="John Smith"
                />
                <TextInput
                  type="email"
                  label="Email"
                  name="email"
                  placeholder="johnsmith@email.com"
                />
              </div>
              <div className={buttonContainerClass}>
                <button type="submit">Save</button>
              </div>
            </Form>
          </Formik>
        </div>
      </ResponsiveContent>
    </ModalOverlay>
  );
};

export default NotYouDetailsModal;
